import { graphql } from "../../gql";
import { useMutation } from "@apollo/client";
import { SpeakingClassLevel } from "../../gql/graphql.ts";
import { useCallback } from "react";

const UpdateUser1on1ClassroomPlanSpeakingLevelMutation = graphql(`
  mutation updateUser1on1ClassroomPlanSpeakingLevel(
    $id: String!
    $speakingLevel: SpeakingClassLevel!
  ) {
    updateUser1on1ClassroomPlanSpeakingLevel(
      id: $id
      speakingLevel: $speakingLevel
    ) {
      ...UserOneOnOneClassroomPlan
    }
  }
`);

export function useUpdateUser1on1ClassroomPlanSpeakingLevel() {
  const [mutate, { loading }] = useMutation(
    UpdateUser1on1ClassroomPlanSpeakingLevelMutation,
  );

  const updateSpeakingLevel = useCallback(
    async (id: string, speakingLevel: SpeakingClassLevel) => {
      await mutate({ variables: { id, speakingLevel } });
    },
    [mutate],
  );

  return { updateSpeakingLevel, loading };
}
